import { IApplicationMenuItem, IAccountMenuItem, IMenuItem } from 'src/types/module_types_menu';
import { IApplication } from 'src/modules/product_module';
import { getActiveRoute } from 'src/core/settings';
import { Hosting } from 'src/core/ahp';

import type { IView } from'../../../pip/library/pi-interop/pi-interop.js';
import navigation from'../../../pip/library/pi-navigation/pi-navigation.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

type TSecondaryMenu = {
  application: IApplicationMenuItem[];
  account: IAccountMenuItem[];
};

export class SecondaryMenuViewRC implements IView {
  id = 'secondary-menu';
  ns = 'ahp';

  region: HTMLElement;
  application: IApplication;

  private __activeRoute: string;
  private __primaryNavigationItems: IMenuItem[];

  constructor(public ahp: Hosting) {}

  mount(region: HTMLElement) {
    const MenuAHP = this.ahp.menu;
    const defaultMenus: TSecondaryMenu = {
      application: [],
      account: []
    };

    const { application, account }: TSecondaryMenu =
      f1.read('/menu/navigation_items', defaultMenus, MenuAHP) ||
      f1.read('/menu/navigation_menus', defaultMenus, MenuAHP);

    const rootURI = getActiveRoute();
    const primaryActive = MenuAHP.getActiveResource(application, rootURI) || {};

    this.__primaryNavigationItems = primaryActive.navigation_items || primaryActive.children || [];

    const navEl = document.createElement('hi-navigation-secondary');

    const willDisplay = (item: IMenuItem): boolean => !item.hidden && item.title != null;
    const addHref = (menuItem: IMenuItem) => {
      const uri = navigation.uri.write(`${MenuAHP.normalizeURI(menuItem.uri || '')}${menuItem.goto_uri || ''}`);
      const item = f1.clone(menuItem);

      item.href = uri;
      return item;
    };

    navEl['sectionActions'] = f1.map(addHref, f1.filter(willDisplay, this.__primaryNavigationItems));
    navEl['topLevelActions'] = f1.map(addHref, f1.filter(willDisplay, application));
    navEl['accountActions'] = f1.map(addHref, f1.filter(willDisplay, account));

    navEl.title = this.ahp.product.configuration.application.title;
    region.appendChild(navEl);

    return Promise.resolve(this);
  }

  stateChange() {
    const activeElementIndex = this.__getActiveRouteIndex(this.__primaryNavigationItems, this.__activeRoute);
    const navEl = document.querySelector('hi-navigation-secondary') as HTMLElement;
    const currentChildren = (navEl.shadowRoot as ShadowRoot).querySelector('#sectionActions__tabGroup');

    (currentChildren as Element).setAttribute('selected-index', activeElementIndex.toString());

    this.__activeRoute = getActiveRoute();
    return Promise.resolve(this);
  }

  __getActiveRouteIndex(routingItems: IMenuItem[], activeRoute: string) {
    return routingItems.findIndex((navResource) => navResource.uri === activeRoute);
  }
}
